import type { CommonNodeType } from '../../types';

export type BusinessScenarioType = {
  id: string;
  name: string;
  type?: string;
};

export type DetailType = {
  id: string;
  title?: string; // 作业标题
  station?: BusinessScenarioType | undefined; //岗位角色
  resume?: string; // 简述
  businessTags?: string[];
  desc?: string;
  bindBusinessScenario?: BusinessScenarioType | undefined;
  
};

export type CrudDataType = {
  id: string;
  data?: string[];
  type: CrudEnumType
}

export enum CrudEnumType {
  create = 'create',
  read = 'read',
  update = 'update',
  delete = 'delete'
}

export type AssignmentNodeType = CommonNodeType & {
  detail: DetailType;
  status: 'online' | 'offline';
  hash?: string | number;
  crudDatas?: CrudDataType[];
};
